import React from 'react';

import Button, { ButtonStyleType } from '@/components/common/Button/Button';

import styles from './control-buttons.module.scss';

interface IControlButtons {
  disabled: boolean;
  onCancel: () => void;
  onConfirm: () => void;

}

function ControlButtons({ disabled, onCancel, onConfirm }: IControlButtons) {
  return (
    <div className={styles.btnWrapper}>
      <Button buttonStyleType={ButtonStyleType.SECONDARY} className={styles.cancelBtn}
        onClick={onCancel}>Cancel</Button>
      <Button buttonStyleType={ButtonStyleType.PRIMARY} disabled={disabled}
        onClick={onConfirm}>Save</Button>
    </div>
  );
}

export default ControlButtons;